// Editor.js block tool for the booking module's widget block. Stores no
// settings — the live site fetches services and slots from the public booking
// API at runtime — so the editor shows a static explanation card only.

const ICON =
  '<svg width="17" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="4" width="18" height="18" rx="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><path d="M9 15l2 2 4-4"/></svg>';

export class BookingTool {
  static get toolbox() {
    return { title: "Booking", icon: ICON };
  }

  render() {
    const root = document.createElement("div");
    root.className = "pgs-gallery-tool";

    const bar = document.createElement("div");
    bar.className = "pgs-gallery-tool__bar";
    const title = document.createElement("span");
    title.className = "pgs-gallery-tool__title";
    title.textContent = "Booking widget";
    bar.appendChild(title);

    const note = document.createElement("div");
    note.className = "pgs-gallery-tool__preview";
    note.textContent =
      "Customers pick a service, date and time here and book straight from your site. " +
      "Manage what's bookable under Bookings — services, hours and rules apply live, without publishing.";

    root.append(bar, note);
    return root;
  }

  save() {
    return {};
  }
}
